import React from "react"
import { Dayjs } from "dayjs"
import { ICustomFieldTemplate } from "../../entities/job/interface"
import { LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { Box, ThemeProvider, Typography } from "@mui/material"
import EventIcon from "@mui/icons-material/Event"
import { DatePicker } from "@mui/x-date-pickers"
import { theme } from "../../styles/theme"

interface Props {
    field: ICustomFieldTemplate
    value: Dayjs | null
    error?: string
    onChange: (id: string, value: Dayjs | null) => void
    isEditable: boolean
}

const DateComponent: React.FC<Props> = ({ field, value, error, onChange, isEditable }) => {
    const [openDatePicker, setOpenDatePicker] = React.useState(false)
    return (
        <ThemeProvider theme={theme}>
            <Box width={"100%"} display={"flex"} flexDirection={"column"}>
                <Box
                    width={"100%"}
                    padding={"10px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    bgcolor={"#027BBA"}
                    borderRadius={"10px"}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={value}
                            disablePast
                            open={openDatePicker}
                            format="MM/DD/YYYY"
                            disabled={!isEditable}
                            onChange={(newValue) => onChange(field.customFieldTemplateId, newValue)}
                            onClose={() => setOpenDatePicker(false)}
                            slotProps={{
                                textField: {
                                    error: !!error,
                                    inputProps: {
                                        style: {
                                            cursor: isEditable ? "pointer" : "not-allowed",
                                        },
                                    },
                                    onClick: () => setOpenDatePicker(true),
                                },
                                actionBar: {
                                    actions: ["clear", "today"],
                                },
                            }}
                            sx={{
                                fontSize: "18px",
                                color: "white",
                                "& .MuiInputBase-root": {
                                    color: "white",
                                    height: 30,
                                    fontSize: "15px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "none",
                                    border: "0px",
                                },
                                "& .MuiPickersModal-root": {
                                    backgroundColor: "#F0F0F0",
                                    color: "white",
                                    width: "100%",
                                },
                                "& .MuiOutlinedInput-root .MuiInputBase-input::placeholder": {
                                    color: "white",
                                },
                                "& .MuiInputAdornment-root": {
                                    display: "none",
                                },
                            }}
                        />
                    </LocalizationProvider>

                    <EventIcon
                        style={{
                            color: isEditable ? "#FFFFFF" : "#A0A0A0", // Change color if not editable
                            cursor: isEditable ? "pointer" : "not-allowed", // Change cursor style if not editable
                        }}
                        onClick={() => {
                            if (!isEditable) return
                            setOpenDatePicker(true)
                        }}
                    />
                </Box>
                <Typography variant="caption" color="error" fontSize={"15px"}>
                    {error}
                </Typography>
            </Box>
        </ThemeProvider>
    )
}

export default DateComponent
